module.exports = __webpack_public_path__ + "img/pg5-article2-text2.3f2a7450.png";